import { CommonModule } from '@angular/common';
import { Component, computed, effect, ElementRef, HostBinding, inject, input, InputSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { setCssValue } from '../../functions/set-css-value.function';
import { LoaderComponent } from '../loader/loader.component';
import { DefaultGridDataCellComponent } from './components/default-grid-data-cell/default-grid-data-cell.component';
import { DefaultGridHeaderCellComponent } from './components/default-grid-header-cell/default-grid-header-cell.component';
import { IGridCell } from './interfaces/igrid-cell.interface';
import { IGridConfig } from './interfaces/igrid-config.interface';
import { GridCellHtmlPipe } from './pipes/grid-cell-html.pipe';

@Component({
	selector: 'lb-data-grid',
	standalone: true,
	imports: [CommonModule, RouterModule, DefaultGridDataCellComponent, DefaultGridHeaderCellComponent, GridCellHtmlPipe, LoaderComponent],
	templateUrl: './data-grid.component.html',
	styleUrl: './data-grid.component.scss'
})
export class DataGridComponent {
	private readonly _elementRef: ElementRef = inject(ElementRef);

	@HostBinding('class.has-header-actions-area') protected _hasHeaderActionArea: boolean = false;
	@HostBinding('class.has-footer-actions-area') protected _hasFooterActionArea: boolean = false;
	@HostBinding('class.cell-borders') protected _cellBorders: boolean = false;

	public gridConfig: InputSignal<IGridConfig> = input.required<IGridConfig>();
	public data: InputSignal<unknown[]> = input.required<unknown[]>();
	public isLoading: InputSignal<boolean> = input(false);

	public noItemsMessage = computed(() => this.gridConfig().noItemsMessage ?? 'No items found...');

	public adjustDataCells(item: unknown): IGridCell[] {
		return this.gridConfig().dataConfig.rowDef.cells.map((cell: IGridCell) => {
			return {
				...cell,
				item
			};
		});
	}

	constructor() {
		effect(() => {
			this._hasHeaderActionArea = this.gridConfig().headerActionAreaComponent !== undefined;
			this._hasFooterActionArea = this.gridConfig().footerActionAreaComponent !== undefined;
			this._cellBorders = this.gridConfig()?.cellBorders || false;

			setCssValue(this._elementRef.nativeElement, '--grid-column-config', `${this.gridConfig().columnConfig}`);
			setCssValue(this._elementRef.nativeElement, '--grid-min-width', this.gridConfig().minWidth ?? 'auto');
		});
	}
}
